function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.285 7.581c-.375-2.904-2.784-5.19-5.837-5.538A7.352 7.352 0 0011.656 2C8.957 2.004 6.527 3.555 5.5 5.93c-1.026 2.374-.446 5.103 1.469 6.911a4.883 4.883 0 011.618 3.548v.733h6.153v-.737a4.771 4.771 0 011.561-3.49c1.5-1.377 2.235-3.345 1.983-5.314zM11.665 22c.652 0 1.232-.391 1.45-.976h-2.9c.217.585.798.975 1.45.976zM9.1 19.56c.001.27.23.488.513.489h4.103a.501.501 0 00.512-.488v-1.463H9.101v1.463z",
  fill: "#1976D2"
});

function SvgSuggestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgSuggestions;